import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 56,
  TESTNET = 97
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

/**
 * @MOUD this is the swapx factory which is retrievable by chainId, with the address of the
 * mainnet and the testnet. previously it looked like this:
 * export const FACTORY_ADDRESS = '0x34b57033beea24a9c78bcaa77c154cf4ae44d1ca'
 */
export const FACTORY_ADDRESS_BY_CHAIN = {
  [ChainId.MAINNET]: '0x585b0B05Cf12d08e44dd98889e0598D61BcfDBcD',
  [ChainId.TESTNET]: '0x254FcDa3B5Ba6595A1350f67e8903a22deba82aE'
}
/**
 * @MOUD This is the intial code hash used to calculate the address of the token pairs.
 * export const INIT_CODE_HASH = '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5'
 */
export const INIT_CODE_HASH_BY_CHAIN = {
  [ChainId.MAINNET]: '0x4791353c12c4030fe1b380dc0623b370b4a1653c56c493ec26e49f015d0886b7',
  [ChainId.TESTNET]: '0x4791353c12c4030fe1b380dc0623b370b4a1653c56c493ec26e49f015d0886b7'
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
